import { FC, ReactNode, FormEvent } from 'react';
import { Box } from '@mui/material';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import {
  FormTitleTypography,
  FormContentBox,
  ButtonContainerBox,
  StyledCircularProgress,
} from 'src/components/DialogBox/POBox/POBox.styles';
import {
  StyledDialog,
  CloseIcon,
  StyledDialogContent,
  SubmitButton,
} from 'src/components/DialogBox/DialogBox.styles';
import { ProductionDialogProps } from 'src/models/Management.interface';

const ProductionDialog: FC<ProductionDialogProps> = ({
  height = '720px',
  width = '984px',
  open,
  handleClose,
  title,
  subtitle,
  formTitle,
  children,
  onSubmit,
  buttonLabel = 'Save',
  buttonWidth = '100px',
  buttonDisabled,
  buttonLoading = false,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width={width}
      height={height}
    >
      <Box sx={{ position: 'relative' }}>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </Box>
      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <form onSubmit={onSubmit}>
            {formTitle && (
              <FormTitleTypography ml={5} mb={2}>
                {formTitle}
              </FormTitleTypography>
            )}
            <FormContentBox>{children}</FormContentBox>
            <ButtonContainerBox>
              <SubmitButton
                className="btn-primary"
                type="submit"
                disabled={buttonDisabled || buttonLoading}
                buttonWidth={buttonWidth}
              >
                {buttonLoading ? (
                  <StyledCircularProgress size={24} />
                ) : (
                  buttonLabel
                )}
              </SubmitButton>
            </ButtonContainerBox>
          </form>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default ProductionDialog;
